'use client';

import { FunctionComponent, useEffect, useState } from 'react';

export interface ScrollToTopProps
{
}

/**
 * Component: ScrollToTop - A button that appears when user scrolls down and allows quick return to top
 */
const ScrollToTop: FunctionComponent<ScrollToTopProps> = () =>
{
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() =>
    {
        const toggleVisibility = () =>
        {
            if (window.scrollY > 300)
            {
                setIsVisible(true);
            }
            else
            {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () =>
    {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    /** Render */
    return (
        <div className={`scroll-to-top ${isVisible ? 'visible' : ''}`}>
            <button
                type="button"
                onClick={scrollToTop}
                className="scroll-to-top-btn"
                aria-label="Scroll to top"
            >
                <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path 
                        d="M12 19V5M5 12L12 5L19 12" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    );
}

export default ScrollToTop;